import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';

@Component({
    selector: 'om-detail-bridge-report',
    templateUrl: './detailBridgeReport.html',
    styleUrls: ['../../reports.css', './detailBridgeReport.css']
})

export class DetailBridgeReportComponent implements OnInit {
    private bridgeId: number;
    reportData;
    error = false;
    errorMessage = this.reportHelper.reportErrorMessages.noReportData;

    constructor(private readonly reportsApi: ReportsApi,
                private readonly reportHelper: ReportHelper,
                private readonly route: ActivatedRoute,
                titleService: Title) {
        titleService.setTitle(titleService.getTitle() + ' : Detail Bridge Report');
    }

    async ngOnInit() {
        this.route.paramMap.subscribe(x => {
            this.bridgeId = JSON.parse(window.localStorage.getItem(x.get('id'))).bridgeId;
            this.loadReport();
        });
    }

    loadReport() {
        return this.reportsApi.getBridgeReportData(this.bridgeId).then((reportData) => {
            this.reportData = reportData;
        }, (error) => {
            this.error = true;
        });
    }
}
